import React from 'react'

import './GradientTitle.styles.scss'

export const GradientTitle = ({
  children
}) => (
  <h1 className={'GradientTitle'}>
    {children}
  </h1>
)
